import React from "react";
import { useParams } from "react-router-dom";
import { createStyles, makeStyles, Grid, Typography, Divider, Paper } from "@material-ui/core";
import ReactApexChart from "react-apexcharts";

const useStyles = makeStyles((theme) =>
createStyles({
  root: {
    display: "grid",
  },
  title:{
    maxHeight: 40,
    padding: 5,
    margin: 0,
  },
  graphic:{
    [theme.breakpoints.up("xs")]: {width: "100%", height: 250},
    [theme.breakpoints.up("sm")]: {width: "100%", height: 250},
    [theme.breakpoints.up("md")]: {width: "100%", height: 250},
    [theme.breakpoints.up("lg")]: {width: "100%", height: 320},
    [theme.breakpoints.up("xl")]: {width: "100%", height: 350},
  }
})
);

function ViewChart({series,}){
  const options = {
    chart:{
     
    },
    labels: ["No prazo", "Em atraso", "Concluído", "Cancelado", ],//"Projeto cancelado" "#CCCC"
    colors: ["#2E93fA", "#FFA500", "#66DA26", "#ff3330", ],
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
        donut: {
          labels: {
            show: true,
            name: {
              fontSize: "25px",
              fontWeight: 550,
            },
            value: {
              fontSize: "25px",
              fontWeight: 550,
              formatter: function (val) {
                return val;
              }
            },
            total: {
              show: true,
              label: "Total",
              formatter: function (w) {
                let series = w.config.series;
                const result = series.reduce(function add(sum, currValue) {
                  return sum + currValue;
                }, 0);
                return result;
              }
            }
          }
        }
      }
    },
    dataLabels: {
      enabled: true,
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'center',
      floating: false,
    },
  };
  return <ReactApexChart options={options} series={series} type="donut" width={"100%"} height={"100%"}
/>
}

export const CardProjects = ({value}) => {
  const classes = useStyles();
  const { id } = useParams();
 
  return (
  <Paper>
  <Grid
    container
    spacing={0}
    className={classes.root}
  >
   <Grid item xs={12} className={classes.title}>
    <Typography gutterBottom variant="h6" align="center">
      Projetos
    </Typography>
    <Divider/>
   </Grid>
    <Grid item xs={12} className={classes.graphic}>
     <ViewChart series={value}/>
    </Grid>
  </Grid>
 </Paper>
);
}

